var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-listado',[_c('page-header',{attrs:{"title":"Plantillas de Contrato"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm","to":"/plantillasContrato/crear"}},[_c('v-icon',{attrs:{"name":"plus","width":"16"}}),_vm._v(" Crear plantilla ")],1)],1),_c('tabla',{attrs:{"plantillas":_vm.plantillas}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }